import { render, staticRenderFns } from "./HeaderClientDetail.vue?vue&type=template&id=ab007a8c&scoped=true"
import script from "./HeaderClientDetail.vue?vue&type=script&lang=js"
export * from "./HeaderClientDetail.vue?vue&type=script&lang=js"
import style0 from "./HeaderClientDetail.vue?vue&type=style&index=0&id=ab007a8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab007a8c",
  null
  
)

export default component.exports